var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(3934), __webpack_require__.e(2558), __webpack_require__.e(957), __webpack_require__.e(3772), __webpack_require__.e(3822), __webpack_require__.e(2308), __webpack_require__.e(8165)]).then(() => (() => ((__webpack_require__(28165)))));
	},
	"./AppDrawerItem": () => {
		return Promise.all([__webpack_require__.e(606), __webpack_require__.e(3934), __webpack_require__.e(2558), __webpack_require__.e(8671), __webpack_require__.e(957), __webpack_require__.e(3772), __webpack_require__.e(3822), __webpack_require__.e(2308), __webpack_require__.e(8980)]).then(() => (() => ((__webpack_require__(68980)))));
	},
	"./AppGridItem": () => {
		return Promise.all([__webpack_require__.e(606), __webpack_require__.e(3934), __webpack_require__.e(2558), __webpack_require__.e(8671), __webpack_require__.e(957), __webpack_require__.e(3772), __webpack_require__.e(3822), __webpack_require__.e(2308), __webpack_require__.e(7963)]).then(() => (() => ((__webpack_require__(67963)))));
	},
	"./DiscoverGridItem": () => {
		return Promise.all([__webpack_require__.e(606), __webpack_require__.e(3934), __webpack_require__.e(2558), __webpack_require__.e(8671), __webpack_require__.e(957), __webpack_require__.e(3772), __webpack_require__.e(3822), __webpack_require__.e(2308), __webpack_require__.e(313)]).then(() => (() => ((__webpack_require__(20313)))));
	},
	"./appDetails": () => {
		return Promise.all([__webpack_require__.e(3934), __webpack_require__.e(2558), __webpack_require__.e(957), __webpack_require__.e(3772), __webpack_require__.e(3822), __webpack_require__.e(2308), __webpack_require__.e(6625)]).then(() => (() => ((__webpack_require__(46625)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});